import React from 'react';
import * as R from 'ramda';
import liendirect from './../../assets/images/svg/049-family.svg';
import autres from './../../assets/images/svg/051-parents.svg';
import parsePhoneNumber from 'libphonenumber-js';

export const ColapsedReferent = ({data, isEditing, setIsEditing, authFacilitaPage, hideResendInvitation}) => {
    var countries = require("i18n-iso-countries");
    countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));
    const gender = { male: 'Male', female: 'Female' };
    const representativeType = {direct: 'Family', other:'Other'};
    const representativeTypeFamily = {Child: 'Fils/Fille', Parent:'Parent', Sibling:'Frère/Soeur', Spouse:'Conjoint'};

    if (R.isNil(data.address)){
        return '';
    }
    const parsedPhoneNumber = !R.isNil(data.phoneNumber) && data.phoneNumber !== "" ? parsePhoneNumber(data.phoneNumber).formatInternational() : undefined;

    return (
        <div className={"card" + (authFacilitaPage ? " p-4 border border-light" : " card-body pb-0 mb-4")}>
            {authFacilitaPage ? '' :
                <React.Fragment>
                    <div className="flex-row align-items-center gx-2">
                        <div className=""></div>
                        <h2 className="h4 text-secondary text-uppercase font-weight-bolder my-auto">{data.isMainRepresentative === true ? '' : 'AUTRE'} MANDATAIRE {data.isMainRepresentative === true? 'PRINCIPAL' : ''}</h2>
                        {
                            hideResendInvitation ?
                                ''
                            :
                                <button type="button" className={"btn text-muted p-0 ml-auto loading-btn btn-if align-items-center"} name="resend">
                                    <span className="aling-middle o-60">Renvoyer invitation</span>
                                    <i className="eva eva-email-outline ml-2 h4 my-auto lh-1 aling-middle"></i>
                                    <div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div>
                                </button>
                        }
                        
                    </div>
                    <hr className="my-3" />
                </React.Fragment>
            }
            
            <div className={authFacilitaPage ? "block mb-3" : "block py-3"}>
                {authFacilitaPage ?
                    '' :
                    <React.Fragment>
                        <h4 className="h6 font-weight-bolder">{data.gender === gender.male ? 'Monsieur' : 'Madame'}</h4>
                        <h3 className="h3 font-weight-bolder mb-4">{data.lastName} {data.firstName}</h3>
                    </React.Fragment>
                }
                <div className="card text-capitalize flex-row align-items-center mb-3">
                    <img className="img-fluid my-auto mb-2 h-5 w-5 py-1" src={data.representativeType === representativeType.other ? autres : liendirect} alt={data.representativeType === representativeType.direct ? "lien familial direct" : "autres"} />
                    <h2 className="h6 font-weight-bolder ml-2 pl-1 mb-0 text-uppercase">{data.representativeType === representativeType.other ? 'Autres' : representativeTypeFamily[data.representativeType]}</h2>
                </div>
                <div className="flex-row align-items-start mb-3">
                    <i className="eva lh-copy eva-calendar-outline mr-2 o-50"></i>
                    <p className="h5 lh-copy my-auto">{new Date(data.birthDate).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })}</p>
                </div>
                <div className="flex-row align-items-start mb-3">
                    <i className="eva lh-copy eva-home-outline mr-2 o-50"></i>
                    <p className="h5 lh-copy my-auto">{data.address.addressLine1} <br />{data.address.postalCode} {data.address.city}, {countries.getName(data.address.country, "fr", {select: "official"})}</p>
                </div>
                {
                    R.isNil(data.email) || data.email === "" ? 
                        ''
                    :
                        <div className="flex-row align-items-start mb-3">
                            <i className="eva lh-copy eva-email-outline mr-2 o-50"></i>
                            <p className="h5 lh-copy my-auto">{data.email}</p>
                        </div>
                }
                {
                    R.isNil(parsedPhoneNumber) ? 
                        ''
                    :
                        <div className="flex-row align-items-start mb-3">
                            <i className="eva lh-copy eva-phone-outline mr-2 o-50"></i>
                            <p className="h5 lh-copy my-auto">{parsedPhoneNumber}</p>
                        </div>
                }
                <button type="button" className="btn btn-block btn-alert-primary loading-btn" name="refPrincipal" onClick={() => {
                    let tmpEditing = JSON.parse(JSON.stringify(isEditing));
                    tmpEditing.push(data.id);
                    setIsEditing(tmpEditing);
                }}>
                    Modifier
                    <div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div>
                </button>
            </div>

            {authFacilitaPage ?
                <div className="flex-row align-items-center">
                    <button type="button" className="btn btn-block btn-alert-info ml-auto" name="refPrincipal" onClick={() => {
                        let tmpEditing = JSON.parse(JSON.stringify(isEditing));
                        tmpEditing.push(data.id);
                        setIsEditing(tmpEditing);
                    }}>Modifier
                        </button>
                </div>
                : ''
            }
        </div>
    )
}